const DESKTOP_MEDIA = "(min-width: 1024px) and (pointer: fine)"

export function smoothMapOptions() {
  const isDesktop = window.matchMedia(DESKTOP_MEDIA).matches

  return {
    scrollWheelZoom: false,
    smoothWheelZoom: false,
    smoothSensitivity: isDesktop ? 5 : 0.85,
    zoomSnap: 0,
    zoomDelta: isDesktop ? 0.75 : 0.5,
    wheelPxPerZoomLevel: isDesktop ? 80 : 120,
    zoomAnimation: true,
    fadeAnimation: true
  }
}

export function enableSmoothMapZoom(map) {
  if (map.smoothWheelZoom) {
    map.smoothWheelZoom.enable()
  } else {
    map.scrollWheelZoom.enable()
  }
}
